import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalizedValue, PaginatedData } from '@app/models/shared.models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PersonRoleService {
  private readonly API_URL = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  public loadPersonRole() {
    const response = this.httpClient.get<PaginatedData<LocalizedValue>>(
      `${this.API_URL}/PersonRole?take=1000`
    );
    return response;
  }

  public loadPersonRoleById(personRoleId: string) {
    const response = this.httpClient.get<LocalizedValue>(
      `${this.API_URL}/PersonRoles/${personRoleId}`
    );
    return response;
  }
}
